// extracted by mini-css-extract-plugin
export var headerCell = "_5e-1";
export var loadingStateCell = "_5e-4";
export var rowWrapper = "_5e-3";
export var standaloneTable = "_5e-5";
export var table = "_5e-0";
export var white = "_5e-2";